var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Container, ContainerDisplays, ContainerFlexGaps, ContainerFlexWraps } from '../../../../templates/container';
import { Chip } from '../../../../atoms/chip';
var PC = function (props) {
    var chipPropsList = props.chipPropsList;
    var containerConfig = {
        display: ContainerDisplays.Flex,
        flexWrap: ContainerFlexWraps.Wrap,
        flexGap: ContainerFlexGaps.Size_2
    };
    return (React.createElement(Container, __assign({}, containerConfig), chipPropsList &&
        (chipPropsList === null || chipPropsList === void 0 ? void 0 : chipPropsList.length) > 0 &&
        (chipPropsList === null || chipPropsList === void 0 ? void 0 : chipPropsList.map(function (chipProps, index) { return (React.createElement(Chip, { key: "product-chip-".concat(index.toString()), label: chipProps.label, color: chipProps.color, background: chipProps.background })); }))));
};
export { PC as ProductChips };
